import { render, staticRenderFns } from "./InformativesTable.vue?vue&type=template&id=7e52fa79&"
import script from "./InformativesTable.vue?vue&type=script&lang=js&"
export * from "./InformativesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports